import { Box, Header, Link } from '@cloudscape-design/components';

export const PUBLIC_SCORECARD_PREVIEW_ID = 'example-scorecard';
export const PUBLIC_SCORECARD_SUBMIT_LABEL = 'Get my grade';

// Headline for the prospect-facing scorecard forms (/create, distributor links, /c/adam).
export function PublicScorecardFormHeader() {
  return (
    <Header
      variant="h1"
      description={
        <>
          Your Google, Yelp and BBB reviews, graded and compared with the competition nearby, in
          just a few seconds.
          <Box variant="span" display="block" margin={{ top: 'xxs' }} fontWeight="bold">
            <Link
              href={`#${PUBLIC_SCORECARD_PREVIEW_ID}`}
              onFollow={(event) => {
                event.preventDefault();
                document
                  .getElementById(PUBLIC_SCORECARD_PREVIEW_ID)
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              See a sample scorecard ↓
            </Link>
          </Box>
        </>
      }
    >
      See your reputation grade.
    </Header>
  );
}
